import { useIntl } from 'react-intl';
import { IconDatabase } from '@rossum/ui/icons/tabler';
import {
  Autocomplete,
  ListItem,
  ListItemText,
  Stack,
  SvgIcon,
  TextField,
} from '@rossum/ui/material';
import { Dataset } from '../../../../../datasets/types';

type DatasetPickerProps = {
  tables: Dataset[];
  value: Dataset | null;
  dataset: string;
  onChange: (datasetName: string) => void;
};

export const DatasetPicker = ({
  tables,
  value,
  dataset,
  onChange,
}: DatasetPickerProps) => {
  const intl = useIntl();

  return (
    <Stack sx={{ width: '50%' }}>
      <Autocomplete
        getOptionLabel={t => t.metadata?.name}
        options={tables}
        value={value}
        isOptionEqualToValue={(option, v) => option.name === v.name}
        onChange={(_, v) => onChange(v ? v.name : '')}
        renderInput={params => (
          <TextField
            {...params}
            label={intl.formatMessage({
              id: 'features.queueSettings.customLookup.mainDataset',
            })}
            variant="outlined"
            size="small"
            slotProps={{
              input: {
                ...params.InputProps,
                startAdornment: dataset ? (
                  <SvgIcon fontSize="medium" sx={{ ml: 1 }}>
                    <IconDatabase />
                  </SvgIcon>
                ) : null,
              },
            }}
          />
        )}
        renderOption={({ key, ...props }, option) => (
          <ListItem key={key} {...props}>
            <ListItemText
              primary={option.metadata?.name}
              secondary={option.metadata?.description}
            />
          </ListItem>
        )}
      />
    </Stack>
  );
};
